//
// Module for the Benefit Payroll Alerts report criteria
//
rs.module("content/reports/criteria/benefitpayrollalertscriteria",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, compositeMonthYearColumnID, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var compositeMonthYearHidden = $.js(jsSelectors.compositeMonthYearHidden);
            var manualCheckBox = filter.js(jsSelectors.manualCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hookup change event for Include Manual checkbox filter
            manualCheckBox.change(includeManualChanged);

            // Changed event for Include Manual checkbox (hookup Ajax call to repopulate grid)
            function includeManualChanged() {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,

                    { includeManual: manualCheckBox.is(":checked") },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            // On grid selection change, update composite month year hidden field based on grid column value
            lrsGridApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {

                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    compositeMonthYearHidden.val(compositeMonthYear);
                }
                else {
                    compositeMonthYearHidden.val("");
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);